import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import { useSiteConfig } from "../context/SiteConfigContext";

const FloatingIcon = () => {
      const { config } = useSiteConfig();
 

  return (
     <a
      href={`https://wa.me/${config?.whatsappNumber}`}
      className="whatsapp-float"
      target="_blank"
      rel="noopener noreferrer"
    >
  <img src="/images/whattsapp-removebg-preview.png" alt="WhatsApp" className="whatsapp-img"/>
    </a>
  );
};

export default FloatingIcon;